import { Box } from '@chatsdet/ui';
import { ScheduledJobsTab } from '../../components/scheduled-jobs/index.js';

export function SuperadminScheduled() {
  return (
    <Box className="space-y-6">
      <ScheduledJobsTab />
    </Box>
  );
}
